"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedinGetAds = exports.linkedinGetAdsResultSchema = exports.linkedinAdSchema = exports.linkedinGetAdsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Args schema
exports.linkedinGetAdsArgsSchema = zod_1.z.object({
    company: zod_1.z.string().describe('Company name to search for ads'),
    keyword: zod_1.z.string().nullish().describe('Keyword to search for in ads'),
    countries: zod_1.z
        .array(zod_1.z.string())
        .nullish()
        .describe('Array of country codes to filter ads by location'),
    startDate: zod_1.z.string().nullish().describe('Start date for ad search (format: YYYY-MM-DD)'),
    endDate: zod_1.z.string().nullish().describe('End date for ad search (format: YYYY-MM-DD)'),
    maxItems: zod_1.z.number().describe('Maximum number of ads to return. Min is 1.').default(10),
});
// Result schema
exports.linkedinAdSchema = zod_1.z.object({
    id: zod_1.z.string().describe('Unique identifier for the ad'),
    adType: zod_1.z.string().describe('Type of the ad'),
    advertiser: zod_1.z.string().describe('Name of the advertiser'),
    advertiserLinkedinPage: zod_1.z.string().describe('LinkedIn page URL of the advertiser'),
    cta: zod_1.z.string().nullish().describe('Call-to-action text'),
    description: zod_1.z.string().nullish().describe('Description of the ad'),
    destinationUrl: zod_1.z.string().nullish().describe('Destination URL when ad is clicked'),
    headline: zod_1.z.string().nullish().describe('Headline of the ad'),
    image: zod_1.z.string().nullish().describe('Image URL of the ad'),
    poster: zod_1.z.string().describe('Name of the poster'),
    posterTitle: zod_1.z.string().describe('Title of the poster'),
    promotedBy: zod_1.z.string().nullish().describe('Who promoted the ad'),
    video: zod_1.z.string().nullish().describe('Video URL of the ad'),
});
exports.linkedinGetAdsResultSchema = zod_1.z.object({
    ads: zod_1.z.array(exports.linkedinAdSchema).describe('Array of LinkedIn ads'),
});
// Tool metadata
exports.linkedinGetAds = (0, common_1.createToolMetadata)({
    id: 'linkedinGetAds',
    displayName: 'LinkedIn Ads Search',
    displayDescription: 'Search for LinkedIn ads by company, keyword, location, and date range',
    category: 'ads',
    color: common_1.BRAND_COLORS.LINKEDIN,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.LINKEDIN),
    icon: 'linkedin',
    argsSchema: exports.linkedinGetAdsArgsSchema,
}, exports.linkedinGetAdsResultSchema);
